import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'

export const postHeight: { [key: string]: string } = {
  mobileSingle: '667px',
  mobileSingleProfile: '667px',
}

export const postWidth = '375px'

export const baseStyles = (display: string, hasAsset: boolean): CSSObject => ({
  width: postWidth,
  height: postHeight[display],
  background: hasAsset ? 'rgba(0,0,0,0.3)' : colors.n8.base,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
})

export const getContainerStyles = (display: string): CSSObject => ({
  width: postWidth,
  height: postHeight[display],
  background: '#FFFFFF',
})
